import { RefSelectProps, Select, SelectProps } from 'antd';
import { forwardRef, ForwardRefRenderFunction } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetClientGroupsQuery } from '../../api/client-groups-api';

type Props = Omit<SelectProps, 'filterOption' | 'showSearch' | 'onSearch' | 'onBlur'>;

const ClientGroupsSelect: ForwardRefRenderFunction<RefSelectProps, Props> = (props, ref) => {
  const { data: clientGroups } = useGetClientGroupsQuery({
    page: 1,
    limit: 999,
  });
  const { t } = useTranslation('client-groups');

  return (
    <Select
      ref={ref}
      filterOption={(input, option) => (option?.children ?? '').toString().toLowerCase().includes(input.toLowerCase())}
      showSearch
      allowClear={true}
      placeholder={t('groupsSelect.placeholder')}
      {...props}
    >
      {clientGroups?.items.map(({ id, name }) => (
        <Select.Option key={id} value={id}>
          {name}
        </Select.Option>
      ))}
    </Select>
  );
};

export default forwardRef(ClientGroupsSelect);
